import { useEffect, useMemo, useState } from "react";

const fieldConfig = [
  {
    key: "newRate",
    label: "New Rate",
    name: "employment--newRate",
    type: "number",
  },
  {
    key: "newRateEffectiveDate",
    label: "Effective Date",
    name: "employment--newRateEffectiveDate",
    type: "date",
  },
  {
    key: "bonusOrAddition",
    label: "Bonus or Addition",
    name: "employment--bonusOrAddition",
    type: "number",
  },
  {
    key: "bonusOrAdditionEffectiveDate",
    label: "Effective Date",
    name: "employment--bonusOrAdditionEffectiveDate",
    type: "date",
  },
];

const getFieldValue = (field, getValues, fallback = "") => {
  const value = getValues?.(field.name);
  const resolvedValue =
    value === null || typeof value === "undefined" ? field.default : value;
  if (resolvedValue === null || typeof resolvedValue === "undefined") {
    return fallback;
  }
  if (field.type === "date" && typeof resolvedValue === "string") {
    return resolvedValue.substring(0, 10);
  }
  return resolvedValue;
};

const PayReviewMatrix = ({
  item,
  getValues,
  setValue,
  disabled,
  onKeyDown,
}) => {
  const fields = item?.fields?.length ? item.fields : fieldConfig;

  const initialValueMap = useMemo(() => {
    return Object.fromEntries(
      fields.map((field) => [
        field.name,
        getFieldValue(field, getValues, field.default ?? ""),
      ]),
    );
  }, [fields, getValues]);

  const [valueMap, setValueMap] = useState(initialValueMap);

  useEffect(() => {
    setValueMap(initialValueMap);
  }, [initialValueMap]);

  const updateField = (fieldName, rawValue) => {
    if (!fieldName) return;

    let nextValue = rawValue;

    if (rawValue === "") {
      nextValue = "";
    } else if (fieldName.includes("EffectiveDate")) {
      nextValue = rawValue;
    } else {
      const parsed = parseFloat(rawValue);
      nextValue = rawValue === "" || Number.isNaN(parsed) ? "" : parsed;
    }

    setValueMap((current) => ({
      ...current,
      [fieldName]: nextValue,
    }));
    setValue(fieldName, nextValue);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === "Tab") {
      e.stopPropagation();
      return;
    }
    onKeyDown?.(e);
  };

  return (
    <div className="pay-review-matrix pay-review-matrix--full-width">
      <div className="pay-review-matrix__grid">
        {fields.map((field) => (
          <div key={field.name} className="pay-review-matrix__cell">
            <label className="pay-review-matrix__label">{field.label}</label>
            <input
              type={field.type}
              min={field.type === "number" ? "0" : undefined}
              step={field.type === "number" ? "0.01" : undefined}
              value={valueMap[field.name] ?? ""}
              disabled={disabled}
              onKeyDown={handleKeyDown}
              onChange={(e) => updateField(field.name, e.target.value)}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PayReviewMatrix;
